// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
export const displayAttrsList = [
	'type',
	'year',
	'make',
	'model',
	'trim',
	'bodyStyle',
	'vin',
	'modelCode',
	'stockNumber',
	'seoSubTitle'
];

export const highlightedAttrs = {
	CLASSIFICATION: 'classificationName',
	FUEL_TYPE: 'normalFuelType',
	ESTIMATED_DELIVERY_DATE: 'estimatedDeliveryDate',
	ON_SITE_VEHICLE: 'onSiteVehicle',
	SHARED_VEHICLE: 'sharedVehicle',
	VEHICLE_VIEWS: 'vehicleViews'
};

export const SIDEBAR_CLASS = 'ddc-vehicle-title-sidebar';
